export default{
    install(Vue){
        var audio = null;
        var playId = null;
        var playStatus = null;
        function $audio() {
            return new Promise((resolve) => {
                if(!audio) {
                    audio = document.createElement('audio');
                    audio.id = 'j-audio';
                    audio.style.visibility = 'hidden';
                    audio.src = '';
                    document.querySelector('body').appendChild(audio);
                }
                resolve();
            })
        };
        $audio.endStatus = false;
        $audio.ended = function(){
            audio.addEventListener('ended', function () {  
                playStatus ='ended';
                playId = null;
                eventbus.$emit("audioPlayer", {type:'ended'});
            }, false);
            audio.addEventListener('error', function (e) {  
                playStatus ='error';
                playId = null;
                eventbus.$emit("audioPlayer", {type:'error',msg:e});
            }, false);
        };
        $audio.setPlayId = function(val){
            playId = val;
        };
        $audio.getPlayId = function(){
            return playId;
        };
        $audio.getPlayStatus = function(){
            return playStatus;
        };
        $audio.setSrc =function(src){
            audio.src = src;
        };
        $audio.resPlay = function(res){
            audio.play();
            playStatus ='play';
        };
        $audio.play = function(res){
            this.setSrc(res.src);
            this.setPlayId(res.playId);
            audio.play();
            playStatus ='play';
        };
        $audio.pause = function(){
            audio.pause();
            //playId = null;
            playStatus ='pause';
            eventbus.$emit("audioPlayer", {type:'pause'});
        };
        
        //初始化
        $audio();
        $audio.ended();
        Vue.audio = Vue.prototype.$audio = $audio;
    }
}


// WEBPACK FOOTER //
// ./src/components/audio.js